import {useContext, useEffect} from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { DataContext } from "../../contexts/DataContext";

const ProtectedRoute = ({ children } : any) => {
    const location = useLocation();
    const dataContext = useContext(DataContext);
    const navigate = useNavigate();
    useEffect(() => {
      if(dataContext.loading) return;

      if (!dataContext.token) {
        sessionStorage.setItem('beforeLogin', location.pathname);
        navigate('/login');
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dataContext.loading, dataContext.token]);


    return children;
  };

  export default ProtectedRoute;